import React, {useState} from 'react';
import {useHistory, useLocation} from "react-router-dom";
import '../styles/IndividualReport.css';
import {deleteUser} from "../apis/research-api";

export const IndividualReport = () => {
    const location = useLocation();
    const history = useHistory();

    const demographicInformation = location.state.user.demographicInformation;
    const {
        age,
        birthOrder,
        educationBoard,
        familyStatus,
        fatherEducation,
        fatherOccupation,
        gender,
        motherEducation,
        motherOccupation,
        religion,
        residence,
        schooltype,
        professionReason
    } = demographicInformation;

    const {
        a,
        b,
        c,
        d,
        e,
        f
    } = location.state.user.categoryWiseScore;

    const disableBackground =() => {
        document.getElementById("ind-rep-cont").style.opacity  = "0.3"
    }

    const handleDeleteOnClick = async (id) => {
        setLoading(true);
        disableBackground();
        const response = await deleteUser(id);
        if (response.success !== null) {
            setLoading(false);
            history.push('/researcher');
        }

        if (response.error !== null) {
            setLoading(false);
            window.alert("Unable to delete at this moment, " +
                "please try again or refresh");
        }
    };

    const [loading, setLoading] = useState(false);

    return (
        <div className='individual-report-container' id='ind-rep-cont'>
            <h3 className='stick-to-top'>DemoGraphic Information</h3>
            <div className='individual-demographic-info'>
                <p><b>Age</b>: {age}</p>
                <p><b>Gender</b>: {gender}</p>
                <p><b>BirthOrder</b>: {birthOrder}</p>
                <p><b>EducationBoard</b>: {educationBoard}</p>
                <p><b>Why did you choose this profession</b>: {professionReason}</p>
                <p><b>FamilyStatus</b>: {familyStatus}</p>
                <p><b>FatherEducation</b>: {fatherEducation}</p>
                <p><b>FatherOccupation</b>: {fatherOccupation}</p>
                <p><b>MotherEducation</b>: {motherEducation}</p>
                <p><b>MotherOccupation</b>: {motherOccupation}</p>
                <p><b>Religion</b>: {religion}</p>
                <p><b>Residence</b>: {residence}</p>
                <p><b>School type</b>: {schooltype}</p>
            </div>

            {
                loading &&
                <>
                    <p className='loading-msg' id='delete-msg'>Deleting record ...please Wait!</p>
                </>
            }

            <h5>Category Wise Score</h5>
            <div className='category-wise-score'>
                <p><b>R: </b>{a}</p>
                <p><b>I: </b>{b}</p>
                <p><b>A: </b>{c}</p>
                <p><b>S: </b>{d}</p>
                <p><b>E: </b>{e}</p>
                <p><b>C: </b>{f}</p>

                <span className='user-code'>{location.state.user.code}</span>
                <button className='delete-btn' onClick={() => handleDeleteOnClick(location.state.user.id)}>
                    Delete this Record
                </button>
            </div>
        </div>
    );
}